"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileTriggerTypes = exports.liteProfile = exports.ConnectionFrequencies = exports.FitnessLevels = void 0;
var lodash_1 = require("lodash");
exports.FitnessLevels = {
    Low: "Low: 0-1 days a minimal effort workouts a week",
    Fair: "Fair: 1-2 days of low-to-moderate intensity workouts a week",
    Moderate: "Moderate: 3-4 days of moderate intensity workouts a week",
    High: "High: 4-6 days of high intensity workouts a week",
    Elite: "Elite: workout as frequently as possible only limited by recovery",
};
exports.ConnectionFrequencies = {
    OftenAsPossible: "As often as possible",
    TwiceAWeek: "Twice a week",
    OnceAWeek: "Once a week",
    TwiceAMonth: "Twice a month",
    OnceAMonth: "Once a month",
    Rarely: "Rarely",
};
var liteProfile = function (p) {
    return (0, lodash_1.pick)(p, [
        "id",
        "createdAt",
        // include triggeredAt so we can manually trigger propogation of updates to
        // denormalized data
        "triggeredAt",
        "name",
        "photoURL",
        "city",
        "state",
        "title",
        "bio",
    ]);
};
exports.liteProfile = liteProfile;
exports.ProfileTriggerTypes = {
    AcceptInvite: "AcceptInvite",
};
//# sourceMappingURL=Profile.js.map